import { envUrl } from '../app/services/environment/EnvironmentService';

const fullUploadPath = '/products/upload';

export const RoutesHelper = {
  fullUpload: () => envUrl(fullUploadPath),
  fullUploadByType: (productType: string) => envUrl(`${fullUploadPath}/${productType}`),
  fullUploadByTypeAndSize: (productType: string, productSize: string) =>
    envUrl(`${fullUploadPath}/${productType}/${productSize}`),
};
